<template>
  <div class="wrap" :style="{backgroundImage: imgShow.sysBgcUrl ? `url(${sysBgcUrl})` : ''}">
    <div class="sys-logo">
      <img v-if="imgShow.logoSrc" :src="logoSrc" alt="">
      <div v-if="logoIntroduction" class="introduction">
        {{ logoIntroduction }}
        <a :href="logoUrl" target="_blank">Here</a>
      </div>
    </div>
    <div class="sys-footer">
      <div v-if="bottomIntroduction" class="introduction">
        {{ bottomIntroduction }}
        <a :href="bottomUrl" target="_blank">Here</a>
      </div>
      <span style="padding-right: 5px;">{{ $t('copyright') }}</span>
      <a style="margin-left: 10px;" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{ $t('forTheRecord') }}</a>
    </div>
    <div class="login-wrap">
      <div class="lang-select">
        <LangSelect />
        <el-button type="primary" size="mini" @click="onBack">{{ $t('login.back') }}</el-button>
      </div>
      <!-- 预登录 -->
      <div v-if="optionType === 'preLogin'" class="login-box box">
        <div class="login-tips login-tips-hello">{{ $t('login.hello') }}</div>
        <div class="login-tips">{{ $t('login.welcomeToSignIn') }}</div>
        <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules" @submit.native.prevent="onPreLogin('loginForm')">
          <template v-if="!disablePasswordLogin">
            <el-form-item prop="username" :label="$t('login.emailAccount')">
              <el-input v-model="loginForm.username" />
            </el-form-item>
            <el-form-item prop="password" :label="$t('login.password')">
              <el-input v-model="loginForm.password" type="password" />
            </el-form-item>
            <div class="forgot-password">
              <el-button type="text" size="mini" @click="onForgotPassword">{{ $t('login.forgotPassword') }}</el-button>
            </div>
            <div>
              <el-button class="btn" type="primary" native-type="submit">{{ $t('login.signIn') }}</el-button>
            </div>
          </template>
          <div>
            <el-button class="btn" type="success" @click="onMicrosoftLogin">{{ $t('login.signInWithMicrosoft') }}</el-button>
          </div>
        </el-form>
      </div>
      <!-- 第三方登录配置选择 -->
      <div v-if="optionType === 'thirdParty'" class="login-box box">
        <div class="login-tips login-tips-hello">{{ $t('login.hello') }}</div>
        <div class="login-tips">{{ thirdPartySource === 'microsoft' ? $t('login.signInWithMicrosoft') : $t('login.thirdPartyLogin') }}</div>
        <el-form ref="thirdPartyForm" :model="thirdPartyForm" :rules="thirdPartyFormRules">
          <el-form-item prop="configId">
            <el-select v-model="thirdPartyForm.configId" style="width: 100%" placeholder="">
              <el-option
                v-for="item in thirdPartyConfigList"
                :key="item.id"
                :label="item.alias"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <div class="back-to-login-btn">
            <el-button type="text" size="mini" @click="onBackToLoginPage">{{ $t('login.backToLoginPage') }}</el-button>
          </div>
          <div>
            <el-button class="btn" type="success" @click="onThirdPartyConfirm">{{ $t('login.signIn') }}</el-button>
          </div>
        </el-form>
      </div>
      <!-- 多租户选择租户 -->
      <div v-if="optionType === 'login'" class="account-box box">
        <div class="login-tips">{{ $t('login.chooseAnAccount') }}</div>
        <el-form ref="accountForm" :model="accountForm" :rules="accountFormRules">
          <el-form-item prop="agentTenantId">
            <vue-select-page
              v-model="accountForm.agentTenantId"
              :multiple="false"
              :filterable="true"
              :clearable="true"
              :options="tenantList"
              :label-key="language === 'zh' ? '{chineseName|name}-{partyId}' : '{name|chineseName}-{partyId}'"
              :value-key="'partyId'"
              class="vue-select-page"
            />
          </el-form-item>
          <div>
            <el-button class="btn" type="primary" @click="onLogin('accountForm')">{{ $t('login.signIn') }}</el-button>
          </div>
        </el-form>
      </div>
      <!-- 找回密码 -->
      <div v-show="optionType === 'retrieve'" class="retrieve-box box">
        <div class="login-tips">{{ $t('login.retrievePassword') }}</div>
        <el-form ref="retrieveForm" :model="retrieveForm" :rules="retrieveFormRules">
          <el-form-item prop="email">
            <el-input v-model="retrieveForm.email" :placeholder="$t('common.userEmail')" />
          </el-form-item>
          <div class="back-to-login-btn">
            <el-button type="text" size="mini" @click="onBackToLoginPage">{{ $t('login.backToLoginPage') }}</el-button>
          </div>
          <div>
            <el-button class="btn" type="primary" :disabled="+timeOutTime > 0" @click="onSendEmail('retrieveForm')">
              {{ +timeOutTime > 0 ? `${$t('login.sendEmail')} ${timeOutTime}s` : $t('login.sendEmail') }}
            </el-button>
          </div>
        </el-form>
      </div>
      <!-- 重置密码 -->
      <div v-if="optionType === 'reset'" class="reset-box box">
        <div class="login-tips">{{ $t('login.resetPassword') }}</div>
        <el-form ref="resetForm" :model="resetForm" :rules="resetFormRules">
          <el-form-item v-if="!aggregatorIsSystemPwd" prop="password">
            <el-input v-model="resetForm.password" type="password" :placeholder="$t('navbar.newPassword')" />
          </el-form-item>
          <el-form-item v-if="!aggregatorIsSystemPwd" prop="password2">
            <el-input v-model="resetForm.password2" type="password" :placeholder="$t('navbar.confirmpassword')" />
          </el-form-item>
          <div class="back-to-login-btn">
            <el-button type="text" size="mini" @click="onBackToLoginPage">{{ $t('login.backToLoginPage') }}</el-button>
          </div>
          <div>
            <el-button class="btn" type="primary" @click="onResetForm('resetForm')">{{ $t('login.resetPassword') }}</el-button>
          </div>
        </el-form>
      </div>
      <!-- 修改密码密码 -->
      <div v-if="['change', 'set'].includes(optionType)" class="change-box box">
        <div class="login-tips">{{ aggregatorIsSystemPwd ? $t('login.resetPassword') : optionType === 'change' ? $t('navbar.changePassword') : $t('login.setPassword') }}</div>
        <el-form ref="changeForm" :model="changeForm" :rules="changeFormRules">
          <el-form-item prop="oldPassword">
            <el-input v-model="changeForm.oldPassword" type="password" :placeholder="$t('login.currentPassword')" />
          </el-form-item>
          <el-form-item v-if="!aggregatorIsSystemPwd" prop="password">
            <el-input v-model="changeForm.password" type="password" :placeholder="$t('navbar.newPassword')" />
          </el-form-item>
          <el-form-item v-if="!aggregatorIsSystemPwd" prop="password2">
            <el-input v-model="changeForm.password2" type="password" :placeholder="$t('navbar.confirmpassword')" />
          </el-form-item>
          <div class="back-to-login-btn">
            <el-button type="text" size="mini" @click="onBackToLoginPage">{{ $t('login.backToLoginPage') }}</el-button>
          </div>
          <div>
            <el-button class="btn" type="primary" @click="onChangeForm('changeForm')">{{ aggregatorIsSystemPwd ? $t('login.resetPassword') : optionType === 'change' ? $t('navbar.changePassword') : $t('login.setPassword') }}</el-button>
          </div>
        </el-form>
      </div>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import RETURN_DATA from '@/utils/data/login'
import LangSelect from './LangSelect'
import VueSelectPage from '@/components/VueSelectPage'
import { common } from '@/api/requestUrl'
import baseUrl from '@/utils/baseUrl'
import { nanoid } from 'nanoid'
import {
  preLogin,
  login,
  retrievePassword,
  resetPassword,
  changePassword,
  getBrandInfoByDomainName,
  getSsoConfig,
  oauthGetTenants
} from '@/api/login'

export default {
  components: {
    LangSelect,
    VueSelectPage
  },
  mixins: [],
  data() {
    return {
      baseURL: baseUrl,
      sysBgcUrl: '',
      logoSrc: '',
      loginForm: { ...RETURN_DATA().LOGIN_FORM }, // 预登录
      loginFormRules: { ...RETURN_DATA().LOGIN_FORM_RULES },
      accountForm: { ...RETURN_DATA().ACCOUNT_FORM }, // 租户选择
      accountFormRules: { ...RETURN_DATA().ACCOUNT_FORM_RULES },
      retrieveForm: { ...RETURN_DATA().RETRIEVE_FORM }, // 找回密码
      retrieveFormRules: { ...RETURN_DATA().RETRIEVE_FORM_RULES },
      resetForm: { ...RETURN_DATA().RESET_FORM }, // 重置密码
      resetFormRules: { ...RETURN_DATA().RESET_FORM_RULES },
      changeForm: { ...RETURN_DATA().CHANGE_FORM }, // 修改密码
      changeFormRules: { ...RETURN_DATA().CHANGE_FORM_RULES },
      tenantList: [], // 租户列表 账户绑定多个租户会显示
      sessionId: '',
      firstLogin: false,
      optionType: 'preLogin', // preLogin预登录 login选择租户登录 retrieve忘记密码发邮件 reset重置密码 change修改密码 set设置密码
      aggregatorIsSystemPwd: false, // 是否系统密码 如果是系统密码修改时无需填写自己的密码 会通过邮件发送系统生成的密码
      clientIp: '',
      thirdPartyConfigList: [],
      thirdPartyForm: { ...RETURN_DATA().THIRD_PARTY_FORM },
      thirdPartyFormRules: { ...RETURN_DATA().THIRD_PARTY_FORM_RULES },
      thirdPartySource: '',
      timeOut: null,
      timeOutTime: 0,
      logoIntroduction: '', // logo介绍
      logoUrl: '', // logo外链
      bottomIntroduction: '', // 底部介绍
      bottomUrl: '', // 底部外链
      imgShow: {
        logoSrc: false,
        sysBgcUrl: false
      },
      redirect: '', // 返回3.0的跳转路径
      msCode: ''
    }
  },
  computed: {
    ...mapGetters(['language']),
    isSuperAdmin() {
      return this.$route.name === 'Superadmin'
    },
    // /login 路由下，指定 hostname 禁用账号密码登录，仅允许微软账号登录
    disablePasswordLogin() {
      // 超级管理员路由下可以使用账号密码登录
      if (this.isSuperAdmin) return false
      const arr = ['localhost', 'qa-crane.etowertech.com', 'uk.etowertech.com']
      return arr.includes(window.location.hostname)
    }
  },
  created() {
    this.msCode = ''
    // 处理第三方 OAuth 回调（URL 中含 code 参数）
    const { code: msCode, state: ssoConfigId } = this.$route.query
    if (msCode) {
      this.msCode = msCode
      this.onOauthCallback(ssoConfigId, msCode)
      return
    }
    // console.log(this.$route)
    const { optionType = '', sessionId, language = '', redirect = '', aggregatorIsSystemPwd = false } = this.$route.query
    this.aggregatorIsSystemPwd = !!aggregatorIsSystemPwd
    if (language) {
      const lang = (language === 'en_US' || language === 'en') ? 'en' : 'zh'
      // this.setLanguage(lang)
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      // this.$router.go(0)
      this.$emit('change', lang)
    }
    // console.log(optionType)
    if (optionType) {
      if (optionType === 'logout') {
        // 退出
        this.$store.dispatch('user/logout').then(() => {
          this.optionType = 'preLogin'
          this.toIndex()
        })
      } else if (optionType === 'change' || optionType === 'set') {
        // 修改密码 设置密码
        this.optionType = optionType
        this.sessionId = sessionId
      } else {
        //  optionType === 'reset'
        // 忘记密码后重置密码
        // 旧格式: optionType=reset?sessionId=xxx（sessionId 嵌在 optionType 里）
        // 新格式: optionType=reset&sessionId=xxx（sessionId 作为独立参数）
        const type = optionType.split('?sessionId')[0]
        const token = sessionId || optionType.split('sessionId=')[1]
        this.sessionId = token
        this.optionType = type
      }
    }
    this.redirect = redirect
    // 添加两次密码校验是否一致rule
    this.passwordNotMatchRules()
    this.getBrandInfoByDomainName()
    this.ensureClientIp()
  },
  methods: {
    // 获取背景图、logo、底部介绍等
    getBrandInfoByDomainName() {
      let host = window.location.host
      const systemHost = localStorage.getItem('systemHost')
      if (!!systemHost && systemHost !== 'null' && systemHost !== 'undefined') {
        host = systemHost
      }
      const params = {
        domainName: host
      }
      const baseURL = this.baseURL
      getBrandInfoByDomainName(baseURL, params).then(res => {
        // 1：部分定制 2：完全定制
        const { typeId = 1 } = res.data
        let data = res.data
        // 完全定制时所有值为空
        if (typeId === 2) data = {}
        const {
          backgroundFileId = '',
          logoFileId = '',
          logoIntroduction = '',
          logoUrl = '',
          bottomIntroduction = '',
          bottomUrl = ''
        } = data
        this.sysBgcUrl = `${baseURL}${common.scanceImg}?imageId=${backgroundFileId}`
        this.logoSrc = `${baseURL}${common.scanceImg}?imageId=${logoFileId}`
        this.logoIntroduction = logoIntroduction
        this.logoUrl = logoUrl
        this.bottomIntroduction = bottomIntroduction
        this.bottomUrl = bottomUrl
        this.imgShow.logoSrc = !!logoFileId
        this.imgShow.sysBgcUrl = !!backgroundFileId
      })
    },
    // 验证密码是否一致
    passwordNotMatchRules(newPassword) {
      this.resetFormRules['password2'].push(
        {
          validator: (rule, value, callback) => {
            if (value !== this.resetForm.password) {
              callback(new Error(this.$t('message.passwordNotMatch')))
            } else {
              callback()
            }
          },
          trigger: ['blur', 'change']
        }
      )
      this.changeFormRules['password2'].push(
        {
          validator: (rule, value, callback) => {
            if (value !== this.changeForm.password) {
              callback(new Error(this.$t('message.passwordNotMatch')))
            } else {
              callback()
            }
          },
          trigger: ['blur', 'change']
        }
      )
    },
    // 返回首页
    toIndex(options) {
      const systemHost = localStorage.getItem('systemHost')
      this.$router.push({
        path: '/index',
        query: {
          brand: systemHost,
          ...options
        }
      })
    },
    // 返回
    onBack() {
      // 返回查件页
      if (this.optionType === 'preLogin') {
        this.toIndex()
      } else {
        this.optionType = 'preLogin'
      }
    },
    // 修改密码
    onChangeForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return
        const doChange = () => {
          const params = {
            sessionId: this.sessionId,
            oldPassword: this.changeForm.oldPassword
          }
          // 使用系统密码 不需要传新密码
          if (!this.aggregatorIsSystemPwd) {
            params.newPassword = this.changeForm.password2
          }
          changePassword(this.baseURL, params).then(res => {
            if (!res.data) {
              // 使用密码时 提示与为reset相关
              const failKey = this.aggregatorIsSystemPwd ? 'message.passwordResetFailed' : 'message.passwordChangeFailed'
              this.$message.error(this.$t(failKey))
              return
            }
            this.$store.dispatch('user/logout').then(() => {
              const successKey = this.aggregatorIsSystemPwd ? 'message.passwordResetSuccess' : 'message.passwordChangeSuccess'
              this.$message({
                type: 'success',
                message: this.$t(successKey)
              })
              this.loginForm.password = ''
              this.optionType = 'preLogin'
              this.$router.replace({ query: null })
            })
          })
        }
        // 使用系统密码重置密码时 需要二次提示
        if (this.aggregatorIsSystemPwd) {
          this.$confirm(this.$t('message.passwordResetConfirm'), this.$t('common.warning'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            doChange()
          }).catch(() => {})
        } else {
          doChange()
        }
      })
    },
    // 重置密码
    onResetForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return
        const doReset = () => {
          const params = { sessionId: this.sessionId }
          if (!this.aggregatorIsSystemPwd) {
            params.password = this.resetForm.password2
          }
          resetPassword(this.baseURL, params).then(res => {
            this.$message({
              type: 'success',
              message: this.$t('success')
            })
            this.loginForm.password = ''
            this.optionType = 'preLogin'
            this.$router.replace({ query: null })
          })
        }
        if (this.aggregatorIsSystemPwd) {
          this.$confirm(this.$t('message.passwordResetConfirm'), this.$t('common.warning'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            doReset()
          }).catch(() => {})
        } else {
          doReset()
        }
      })
    },
    // 忘记密码
    onForgotPassword() {
      this.optionType = 'retrieve'
    },
    // 发送找回密码邮件
    onSendEmail(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return
        this.$confirm(this.$t('message.retrieveTips'), this.$t('common.warning'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }).then(() => {
          clearTimeout(this.timeOut)
          this.timeOut = null
          this.timeOutTime = 60
          this.countDown()
          const params = {
            ...this.retrieveForm
          }
          const { origin = '', pathname = '' } = window.location
          const sysUrl = pathname.split('/')[1]
          let href = origin
          if (sysUrl) {
            href = `${origin}/${sysUrl}`
          }
          params.returnUrl = href + '/#/login?optionType=reset'
          retrievePassword(this.baseURL, params).then(res => {
            if (!res.data) {
              this.$message.error(this.$t('message.sendEmailFailed'))
              clearTimeout(this.timeOut)
              this.timeOut = null
              this.timeOutTime = 0
              return
            }
            this.$message({
              type: 'success',
              message: this.$t('success')
            })
          })
        }).catch(() => {})
      })
    },
    // 时间倒计时
    countDown() {
      if (this.timeOutTime <= 0) {
        clearTimeout(this.timeOut)
        this.timeOut = null
        return
      }
      this.timeOutTime--
      this.timeOut = setTimeout(() => {
        this.countDown()
      }, 1000)
    },
    // 返回登录
    onBackToLoginPage() {
      this.optionType = 'preLogin'
    },
    // 登录 多租户时选择账户
    onLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return
        const params = {
          sessionId: this.sessionId,
          ...this.accountForm
        }
        this.loginFn(params)
      })
    },
    async ensureClientIp() {
      if (this.clientIp) return
      const fetchIp = url => fetch(url).then(res => res.json()).then(data => data.ip)
      try {
        this.clientIp = await Promise.any([
          fetch('https://ipv4.icanhazip.com/').then(res => res.text()).then(text => text.trim()),
          fetchIp('https://api.ipify.org?format=json')
        ]) || ''
      } catch {
        this.clientIp = ''
      }
    },
    getLoginExtraParams() {
      const STORAGE_KEY = 'clientId'
      let fingerPrint = localStorage.getItem(STORAGE_KEY)
      if (!fingerPrint) {
        fingerPrint = nanoid()
        localStorage.setItem(STORAGE_KEY, fingerPrint)
      }
      return {
        hostname: window.location.hostname,
        ip: this.clientIp,
        fingerPrint
      }
    },
    // 登录
    loginFn(params) {
      // 微软登录时，msCode有值，isOAuth2为1 不校验ipwhitelist clientId
      if (this.msCode) params.isOAuth2 = 1
      else params.isOAuth2 = 0
      login(this.baseURL, { ...params, ...this.getLoginExtraParams() }).then(res => {
        if (res.code === '0080') {
          this.$message.error(this.$t('message.passwordExpired'))
          try {
            const obj = JSON.parse(res.message || '{}')
            this.aggregatorIsSystemPwd = !!obj.aggregatorIsSystemPwd
          } catch {
            this.aggregatorIsSystemPwd = false
          }
          this.optionType = 'change'
          return
        }
        if (res.code === '0081') {
          this.$message.error(this.$t('message.ipNotAllowed', { ip: this.clientIp }))
          return
        }
        if (res.code === '0082') {
          this.$message.error(this.$t('message.deviceNotRegistered'))
          return
        }
        if (res.code !== '0') {
          this.$message.error(res.message)
          return
        }
        const { authUser = {}, party = {}} = res.data || {}
        if (this.firstLogin) {
          this.sessionId = authUser.sessionId
          this.optionType = 'set'
          return
        }
        // this.sessionId = authUser.sessionId
        // 无3个系统 跳转到首页
        if (!party.aggregator && !party.carrier && !party.shipper) {
          this.toIndex({
            sessionId: authUser.sessionId
          })
          return
        }
        const { origin } = location
        // const sysUrl = pathname.split('/')[1]
        if (party.aggregator) {
          // 跳转集成商
          let href = `${origin}/aggregator`
          this.to3System(href, authUser.sessionId)
        } else if (party.carrier) {
          // 跳转运营商
          let href = `${origin}/logistor`
          this.to3System(href, authUser.sessionId)
        } else if (party.shipper) {
          // 跳转承运商
          let href = `${origin}/shipper`
          this.to3System(href, authUser.sessionId)
        }
      })
    },
    // 第三方 OAuth 回调处理，逻辑与 preLogin 一致
    async onOauthCallback(ssoConfigId, authCode) {
      const res = await oauthGetTenants(this.baseURL, { ssoConfigId, authCode })
      if (res.code === '0083') {
        this.$message.error(this.$t('message.oauthUserNotMatched'))
        return
      }
      if (res.code === '0084') {
        this.$message.error(this.$t('message.oauthServiceUnavailable'))
        return
      }
      if (res.code !== '0') {
        this.$message.error(res.message)
        return
      }
      const { tenantList = [], user = {}} = res.data || {}
      this.sessionId = user.sessionId
      this.firstLogin = !!user.firstLogin
      this.tenantList = tenantList
      // 多租户时显示选择列表，单租户直接登录
      if (tenantList.length > 1) {
        this.optionType = 'login'
      } else {
        this.loginFn({ sessionId: user.sessionId })
      }
    },
    // 第三方登录
    async onMicrosoftLogin() {
      const res = await getSsoConfig(this.baseURL, { ssoType: 0 })
      this.thirdPartyConfigList = res.data || []
      this.thirdPartyForm = { ...RETURN_DATA().THIRD_PARTY_FORM }
      this.thirdPartySource = 'microsoft'
      // 如果只配置一个 直接使用这个sso配置登录 不进入三方配置选择
      if (this.thirdPartyConfigList.length === 1) {
        this.thirdPartyForm.configId = this.thirdPartyConfigList[0].id
        this.thirdPartyConfirmFn()
      } else {
        this.optionType = 'thirdParty'
      }
    },
    // 第三方登录跳转到微软
    thirdPartyConfirmFn() {
      const config = this.thirdPartyConfigList.find(item => item.id === this.thirdPartyForm.configId)
      if (!config) return
      if (config.ssoType === 0) {
        const clientId = config.clientId
        const authUrl_tenantId = config.tenantId
        const redirectUrl = config.redirectUrl
        const params = new URLSearchParams({
          client_id: clientId,
          response_type: 'code',
          redirect_uri: redirectUrl,
          scope: 'openid profile email',
          response_mode: 'query',
          state: config.id
        })
        window.location.href = `${authUrl_tenantId}authorize?${params}`
      }
    },
    // 第三方登录确认按钮
    onThirdPartyConfirm() {
      this.$refs.thirdPartyForm.validate(valid => {
        if (!valid) return
        this.thirdPartyConfirmFn()
      })
    },
    // 跳转3.0系统
    to3System(path, sessionId) {
      let host = window.location.host
      const systemHost = localStorage.getItem('systemHost')
      if (!!systemHost && systemHost !== 'null' && systemHost !== 'undefined') {
        host = systemHost
      }
      let href = `${path}/#/sessionRedirect?brand=${host}&language=${this.language === 'zh' ? 'zh_CN' : 'en_US'}&sessionId=${sessionId}`
      if (this.redirect) href += '&redirect' + this.redirect
      window.location.href = href
    },
    // 预登录
    onPreLogin(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) return
        // superadmin 路由下，仅允许 walltechsystem.cn / walltechsystem.com 邮箱登录
        if (this.isSuperAdmin) {
          const username = this.loginForm.username || ''
          const allowed = username.endsWith('@walltechsystem.cn') || username.endsWith('@walltechsystem.com')
          if (!allowed) {
            this.$message.error(this.$t('message.superAdminOnly'))
            return
          }
        }
        await this.ensureClientIp()
        preLogin(this.baseURL, { ...this.loginForm }).then(res => {
          const { tenantList = [], user = {}} = res.data || {}
          this.sessionId = user.sessionId
          this.firstLogin = !!user.firstLogin
          // if (user.firstLogin) {
          //   this.optionType = 'set'
          //   return
          // }
          this.tenantList = tenantList
          // 多租户时选择账户
          if (tenantList.length > 1) {
            this.optionType = 'login'
          } else {
            this.loginFn({ sessionId: user.sessionId })
          }
        })
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.wrap {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  .introduction {
    a {
      color: inherit;
      text-decoration: underline;
    }
    a:hover {
      color: #1890ff;
      text-decoration: underline;
    }
  }
  .sys-logo {
    position: absolute;
    width: 66%;
    height: 100%;
    padding-left: 80px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    img {
      height: 200px;
      margin-bottom: 15px;
    }
  }
  .sys-footer {
    position: absolute;
    bottom: 20px;
    padding-left: 80px;
    width: 66%;
    font-size: 12px;
    color: #fff;
    .introduction {
      margin-bottom: 20px;
      font-size: 16px;
      color: #000;
    }
  }
  .login-wrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 450px;
    background-color: rgba(215, 215, 215, 0.9);
    padding-bottom: 60px;
    .btn {
      width: 100%;
      font-size: 18px;
      margin-top: 5%;
    }
    .back-to-login-btn {
      text-align: left;
    }
    .lang-select {
      padding-top: 20px;
      text-align: right;
      padding-right: 20px;
      position: relative;
      z-index: 1;
    }
    .box {
      width: 80%;
      max-width: 380px;
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
      .login-tips {
        font-size: 26px;
        margin-bottom: 10%;
      }
      .login-tips-hello {
        font-weight: bold;
        font-size: 30px;
        margin-bottom: 5%;
      }
    }
    .login-box {
      .forgot-password {
        text-align: right;
      }
    }
    .account-box {
      .vue-select-page {
        ::v-deep .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>
